var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "footer",
    { attrs: { id: "page-footer" } },
    [
      _vm._t("default", function () {
        return [
          _c(
            "section",
            { staticClass: "footer-wrapper web-centered text-left" },
            [
              _c("section", { staticClass: "row-first" }, [
                _c(
                  "section",
                  { staticClass: "footer-buttons-wrapper" },
                  _vm._l(_vm.buttonContent, function (button, i) {
                    return _c(
                      "button",
                      {
                        key: i,
                        staticClass: "text-white-main",
                        attrs: { variant: "no_background" },
                        on: {
                          click: function ($event) {
                            return _vm.moveTo(button.to)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t(button.title)) +
                            "\n          "
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]),
              _c("section", { staticClass: "comp-name" }, [
                _vm._m(0),
                _c("article", { attrs: { id: "xsolla-description" } }, [
                  _c("img", {
                    staticClass: "xsolla",
                    attrs: {
                      src: `${_vm.$s3}/img/common/xsolla.webp?${_vm.$ver}`,
                    },
                  }),
                  _vm._v(
                    "\n          Xsolla is an authorized global distributor of Open Meta City\n        "
                  ),
                ]),
                _c("article", [
                  _vm._v("Copyright ⓒ Open Meta Inc. All rights reserved"),
                ]),
              ]),
            ]
          ),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        attrs: {
          id: "chainlink",
          href: "https://chain.link/badge",
          target: "_blank",
        },
      },
      [
        _c("img", {
          attrs: {
            src: "https://chain.link/badge-randomness-white",
            alt: "randomness secured with chainlink",
          },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }